import React from "react"
import { CardType } from "../../../lib/utils"
import { getBatchPaymentDetails, getLoansTotalRepayment } from "../financierHelper"
import FinancierBatchCard from "./Card"
import ManageFinancierBatch from "./ManageItem"
import propTypes from "prop-types"

class FinancierFillDetails extends React.Component {

  _isMounted = false

  state = {
    allUpfrontPayment: 0,
    allTotalRepayment: 0,
    runningRepaymentSummary: false,
  }

  componentDidMount() {
    this._isMounted = true
    this.loadPaymentDetails(this.props.financierBatch)
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  loadPaymentDetails = financierBatch => {

    const { upfrontTotal, fineractIds } = getBatchPaymentDetails(financierBatch)
    this.setState({
      allUpfrontPayment: upfrontTotal,
      allTotalRepayment: 0,
      runningRepaymentSummary: false,
    })

    if (fineractIds.length) {

      this.setState({ runningRepaymentSummary: true })

      getLoansTotalRepayment(fineractIds)
      .then(allTotalRepayment => {

        if (this._isMounted) {
          this.setState({ allTotalRepayment })
        }
      })
      .catch(error => console.error(error))
      .finally(() => {

        if (this._isMounted) {
          this.setState({ runningRepaymentSummary: false })
        }
      })
    }
  }

  render() {

    const { allUpfrontPayment, allTotalRepayment, runningRepaymentSummary } = this.state

    return (
      <FinancierBatchCard
        { ...this.props }
        allUpfrontPayment={ allUpfrontPayment }
        allTotalRepayment={ allTotalRepayment }
        runningRepaymentSummary={ runningRepaymentSummary }
      />
    )
  }
}

FinancierFillDetails.propTypes = {
  financierBatch: propTypes.object.isRequired,
}

export default function FinancierBatchDetails({ params }) {

  return <ManageFinancierBatch
    params={ params }
    callback={ (data, setFinancierBatch, reloadFinancierBatch, removeFinancierBatch, buckets) =>
      <FinancierFillDetails 
        financierBatch={ data } 
        setFinancierBatch={ setFinancierBatch }
        reloadFinancierBatch={ reloadFinancierBatch }
        removeFinancierBatch={ removeFinancierBatch }
        cardType={ CardType.LARGE }
        buckets={ buckets }
      />
    }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/Details.js